import KTTable from "general/components/OtherKeenComponents/KTTable";
import KTPagination, { KTPaginationColor } from "general/components/OtherKeenComponents/KTPagination"; // Đảm bảo import đúng
import tableStyle from "general/components/OtherKeenComponents/KTTable/tableStyle";
import UIHelper from "general/helpers/UIHelper";
import { useMemo, useState } from "react";
import systemNotificationList from 'assets/excels/systemNotification.json';

function SystemNotificationTabView() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const paginatedData = useMemo(() => {
        const start = page * rowsPerPage;
        const end = start + rowsPerPage;
        return systemNotificationList.slice(start, end);
    }, [page, rowsPerPage]);

    const total = systemNotificationList.length;
    const currentItemInPageCount = paginatedData.length;

    const columns = useMemo(() => [
        {
            name: UIHelper.buildTableColumn('Mã thông báo'),
            selector: (row) => row?.notificationCode,
            width: '110px',
            style: tableStyle.columns.normal,
        },
        {
            name: UIHelper.buildTableColumn('Trường hợp thông báo'),
            selector: (row) => row?.notificationCase,
            minWidth: '250px',
            style: tableStyle.columns.normal,
            wrap: true,
        },
        {
            name: UIHelper.buildTableColumn('Người nhận'),
            selector: (row) => row?.receiver,
            width: '250px',
            style: tableStyle.columns.normal,
            wrap: true,
        },
        {
            name: UIHelper.buildTableColumn('Tiêu đề'),
            selector: (row) => row?.title,
            minWidth: '250px',
            style: tableStyle.columns.normal,
            wrap: true,
        },
        {
            name: UIHelper.buildTableColumn('Nội dung thông báo'),
            selector: (row) => row?.message,
            minWidth: '400px',
            style: tableStyle.columns.normal,
            wrap: true,
        },
        {
            name: UIHelper.buildTableColumn('Danh mục'),
            selector: (row) => row?.category,
            width: '150px',
            style: tableStyle.columns.normal,
            wrap: true,
        },
        {
            name: UIHelper.buildTableColumn('Liên kết đến'),
            selector: (row) => row?.link,
            width: '120px',
            style: tableStyle.columns.normal,
            wrap: true,
        },
        {
            name: UIHelper.buildTableColumn('Hình thức'),
            selector: (row) => row?.format,
            width: '140px',
            style: tableStyle.columns.normal,
            wrap: true,
        },
    ], []);

    return (
        <div className="px-4">
            <KTTable
                columns={columns}
                items={paginatedData}
                selectableRows={false}
                striped={false}
                compactGrid={false}
                hasActionColumn={false}
                onClickedRow={() => { }}
                onSelectedRowsChanged={() => { }}
                onDoubleClickedRow={() => { }}
                noDataComponent={UIHelper.buildEmptyNoData(
                    'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                )}
            />

            <div className="px-4 mt-2">
                <KTPagination
                    currentPage={page + 1}
                    rowCount={total}
                    rowsPerPage={rowsPerPage}
                    currentItemInPageCount={currentItemInPageCount}
                    onChangePage={(newPage) => {
                        const iNewPage = parseInt(newPage);
                        setPage(iNewPage - 1);
                    }}
                    onChangeRowsPerPage={(newRowsPerPage) => {
                        const iNewRowsPerPage = parseInt(newRowsPerPage);
                        setRowsPerPage(iNewRowsPerPage);
                        setPage(0);
                    }}
                    loading={false}
                    color={KTPaginationColor.success}
                    appendText="mẫu thông báo"
                />
            </div>
        </div>
    );
}

export default SystemNotificationTabView;